import type { IconData } from '@stacksjs/iconify-core'

export const addBellNotification: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"m42 29.575l1.471 2.384c1.478 2.393.672 4.866-2.116 5.237C38.167 37.62 32.843 38 24 38s-14.167-.38-17.355-.804c-2.788-.37-3.594-2.844-2.117-5.237L6 29.575a16 16 0 0 0 2.325-7.037l.48-5.589C9.392 10.081 14.47 4.6 21 3.296\"/><path d=\"M21 15a12 12 0 1 0 24 0a12 12 0 1 0-24 0m12-5v10m0-11v12m5-6H28m11 0H27M16.048 37.878a8.001 8.001 0 0 0 15.904 0\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default addBellNotification
